<form *ngIf="block && form" [formGroup]="form">
  <pl-input
    #plInput
    [label]="block.data.label"
    [formControlName]="FormControlName.input"
    [isFormSubmitted]="courseContentService.isMainFormSubmitted()"
    [invalidatePatternValidationIfEmojiInValue]="invalidatePatternValidationIfEmojiInValue"
    [isDisabled]="isDisabled"
    [name]="block.data.name"
    [type]="block.data.config.type"
    [placeholder]="block.data.placeholder || ''"
  />
</form>
